import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cbf63d08"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "selected-body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FilterSectionTitle = _resolveComponent("FilterSectionTitle");
  const _component_trash_icon = _resolveComponent("trash-icon");
  const _component_b_button = _resolveComponent("b-button");
  const _component_FlexRow = _resolveComponent("FlexRow");
  const _component_WrapWithSection = _resolveComponent("WrapWithSection");
  return $props.count > 0 ? (_openBlock(), _createBlock(_component_WrapWithSection, {
    key: 0,
    id: "selected-section",
    background: "#edf5ff",
    selected: "",
    heightFromTop: $props.heightFromTop
  }, {
    title: _withCtx(() => [_createVNode(_component_FilterSectionTitle, {
      title: $props.title,
      count: $props.count,
      searching: $props.searching,
      selected: "",
      color: "var(--market-700)",
      countColor: "var(--market-700)"
    }, null, 8, ["title", "count", "searching"])]),
    actions: _withCtx(() => [_createVNode(_component_FlexRow, {
      gap: 14,
      classes: "actions"
    }, {
      default: _withCtx(() => [!$props.no_reset ? (_openBlock(), _createBlock(_component_b_button, {
        key: 0,
        variant: "link",
        size: "sm",
        class: "clear-selection-button",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('clear'))
      }, {
        default: _withCtx(() => [_createVNode(_component_trash_icon, {
          width: 16,
          height: 16
        }), _createTextVNode(" Clear selection ")]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    })]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)])]),
    _: 3
  }, 8, ["heightFromTop"])) : _createCommentVNode("", true);
}